module.exports = __webpack_public_path__ + "img/grandma_veda-min.73be55a0.png";